export default __webpack_public_path__ + "static/card-4-1dc176e3412535554236a9ba6bf57a79.svg";